import { render, staticRenderFns } from "./_form.vue?vue&type=template&id=40c5d648&"
import script from "./_form.vue?vue&type=script&lang=js&"
export * from "./_form.vue?vue&type=script&lang=js&"
import style0 from "./_form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports